import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Dimmer, Loader } from 'semantic-ui-react';
import { EventFormStore, EventFormViewModel, EventTrainingViewModel } from 'stores/events/event-form-store';
import { nameof } from 'utils/object';
import TailwindCustomizationDataEditor from 'widgets/bussiness/customization-data-editor-tw';
import TailwindDeliveryMethodEditor from 'widgets/bussiness/delivery-method-editor-tw';
import TailwindLanguageEditor from 'widgets/bussiness/language-editor-tw';
import TailwindTrainingLevelEditor from 'widgets/bussiness/training-level-editor-tw';

interface EventTrainingDetailsContainerProp {
  event: EventFormViewModel;
  readOnly?: boolean;
  loading: boolean;
  eventFormStore?: EventFormStore;
}

const EventTrainingDetailsContainer: React.FC<EventTrainingDetailsContainerProp> = ({ event, readOnly, loading, eventFormStore }) => {
  const { t } = useTranslation();

  const trainingDetails = event.trainingDetails;

  const handleOnEventTrainingChange = (propertyName: string, value: any) => {
    let trainingDetails = { ...event.trainingDetails };
    trainingDetails[propertyName] = value;
    eventFormStore.change({ trainingDetails });
  };

  return (
    <div className="space-y-4">
      {loading && (
        <div style={{ height: 200 }}>
          <Dimmer active inverted>
            <Loader size="large" active inverted />
          </Dimmer>
        </div>
      )}

      <div>
        <label className="text-sm text-gray-700">{t('Training level')}</label>
        <TailwindTrainingLevelEditor
          placeholder={t('Training Level')}
          readOnly={readOnly}
          className="w-full border border-gray-300 p-2 rounded bg-gray-100"
          nullable
          value={trainingDetails.trainingLevel}
          onChange={value => handleOnEventTrainingChange(nameof<EventTrainingViewModel>('trainingLevel'), value)}
          loadDataOnOpen={false}
        />
      </div>

      {(!readOnly || trainingDetails.customizationData) && (
        <div>
          <label className="text-sm text-gray-700">{t('Customization')}</label>
          <TailwindCustomizationDataEditor
            placeholder={t('Customization')}
            readOnly={readOnly}
            className="w-full border border-gray-300 p-2 rounded bg-gray-100"
            nullable
            value={trainingDetails.customizationData}
            onChange={value => handleOnEventTrainingChange(nameof<EventTrainingViewModel>('customizationData'), value)}
            loadDataOnOpen={false}
          />
        </div>
      )}

      <div>
        <label className="text-sm text-gray-700">{t('Delivery Method')}</label>
        <TailwindDeliveryMethodEditor
          placeholder={t('Delivery Method')}
          readOnly={readOnly}
          className="w-full border border-gray-300 p-2 rounded bg-gray-100"
          nullable
          value={trainingDetails.deliveryMethod}
          onChange={value => handleOnEventTrainingChange(nameof<EventTrainingViewModel>('deliveryMethod'), value)}
          loadDataOnOpen={false}
        />
      </div>

      {(!readOnly || trainingDetails.language) && (
        <div>
          <label className="text-sm text-gray-700">{t('Language')}</label>
          <TailwindLanguageEditor
            placeholder={t('Delivery Method')}
            readOnly={readOnly}
            className="w-full border border-gray-300 p-2 rounded bg-gray-100"
            nullable
            value={trainingDetails.language}
            onChange={value => handleOnEventTrainingChange(nameof<EventTrainingViewModel>('language'), value)}
            loadDataOnOpen={false}
          />
        </div>
      )}
    </div>
  );
};

export default connect(['eventFormStore', EventFormStore])(EventTrainingDetailsContainer);
